import { PopoverPlacement } from "@idui/react-popover";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import clsx from "clsx";
import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  FramerTooltip,
  getUserUpdaterIcon,
  userUpdaterModes,
} from "@ryde/controls";
import { areFiltersPausedSF, TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

import { useUserUpdaterRideToggleInternal } from "./use-user-updater-toogle";
import { UserUpdaterRideToggleWrapper } from "./user-updater-ride-toggle.styled";

export const UserUpdaterRideToggle: FC = () => {
  const {
    anchorRef,
    open,
    isMobile,
    selectedValue,
    optionTextByValue,
    ridesCountBySelection,
    handleClick,
    handleToggle,
    handleClose,
    handleMenuItemClick,
    ridesCountByViewMode,
  } = useUserUpdaterRideToggleInternal();
  const isBorderSuspended = useRecoilValue(areFiltersPausedSF("ride"));

  return (
    <UserUpdaterRideToggleWrapper>
      <ButtonGroup
        className={clsx({
          "user-updater-dropdown": true,
          "user-updater-border__suspended": isBorderSuspended,
        })}
        data-e2e="updater_user_toggle"
        variant="outlined"
        size={isMobile ? "small" : "large"}
        ref={anchorRef}
      >
        <FramerTooltip
          content={optionTextByValue(selectedValue)}
          placement={PopoverPlacement.top}
          mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
        >
          <Button onClick={handleClick}>
            {getUserUpdaterIcon(selectedValue)}
            <label className="user-updater__counter">
              {ridesCountBySelection}
            </label>
          </Button>
        </FramerTooltip>
        <Button
          size="small"
          onClick={handleToggle}
          className="user-updater-group-button"
        >
          <ArrowDropDownIcon className="arrow-button" />
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement="bottom-start"
        className="user-updater-popper"
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper elevation={8}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList data-e2e="user-updated-dropdown-list" autoFocusItem>
                  {userUpdaterModes.map(userUpdaterMode => (
                    <MenuItem
                      key={userUpdaterMode}
                      sx={{ gap: "8px" }}
                      selected={selectedValue === userUpdaterMode}
                      className="user-updater-item"
                      onClick={event =>
                        handleMenuItemClick(event, userUpdaterMode)
                      }
                    >
                      {getUserUpdaterIcon(userUpdaterMode)}
                      <span>{optionTextByValue(userUpdaterMode)}</span>
                      <strong>{ridesCountByViewMode(userUpdaterMode)}</strong>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </UserUpdaterRideToggleWrapper>
  );
};
